export default "__VITE_ASSET__CU_A3WQr__"